export const EMPTY_VALUE_ID = 'empty_id'
